import React from 'react';
import PropTypes from 'prop-types';
import {Modal} from 'antd';
import TranslatedText from '../TranslatedText';
import {ReactComponent as ArrowRight} from '../../assets/img/arrowRight.svg';
import {USER_AGREEMENT_MODAL_ID} from '../../services/constants';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import {isModalOpened, modalData} from '../../redux/selectors/nav';
import {makeAction} from '../../redux/actions/makeAction';
import {CLOSE_MODAL, OPEN_MODAL} from '../../redux/actions/actionTypes';
import _ from 'lodash';

class UserAgreementModal extends React.Component {
  constructor(props) {
    super(props);
    this.onCancel = this.onCancel.bind(this);
  }

  onCancel() {
    this.props.closeModal();
    const prevOpened = _.get(this.props.data, 'prevOpened');
    if(prevOpened) {
      this.props.openModal({id: prevOpened});
    }
  }

  render() {
    return (
      <Modal
        title={
          <React.Fragment>
            <span className="header-icon" onClick={this.onCancel}><ArrowRight/></span>
            <span className="header-text"><TranslatedText transKey="modals.agreement.title"/></span>
          </React.Fragment>
        }
        className="nav-modal agreement-modal"
        width={440}
        visible={this.props.opened}
        closable={false}
        onCancel={this.onCancel}
        footer={null}
      >
        <div>
          {
            this.props.t('modals.agreement.content').split('\n').filter(text => text.length > 0).map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))
          }
        </div>
      </Modal>
    );
  }
}

UserAgreementModal.propTypes = {
  opened: PropTypes.bool.isRequired,
  data: PropTypes.object,
  closeModal: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  opened: isModalOpened(state)(USER_AGREEMENT_MODAL_ID),
  data: modalData(state),
});

const mapDispatchToProps = {
  openModal: makeAction(OPEN_MODAL),
  closeModal: makeAction(CLOSE_MODAL),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(UserAgreementModal));



// WEBPACK FOOTER //
// /src/components/modals/UserAgreementModal.jsx